import * as React from 'react';
import { Button } from '../../components/Bootstrap';
import { DateRange } from './types';
import { DatePicker } from './DatePicker';

interface DatePickerPopupProps {
  selected: DateRange;
  toggle();
  update(start: Date, end: Date);
}

export const DatePickerPopup = ({ selected, toggle, update }: DatePickerPopupProps) => {
  const [range, setRange] = React.useState<DateRange>(selected);

  React.useEffect(() => {
    setRange(selected);
  }, [selected]);

  const onClickUpdate = React.useCallback(() => {
    update(range.start, range.end);
  }, [update, range]);

  const onSelect = React.useCallback(
    ({ start, end }) => {
      setRange({ start, end });
    },
    [setRange]
  );

  return (
    <div className='date-picker-popup'>
      <div className='date-picker-popup-container'>
        <DatePicker selected={selected} onSelect={onSelect} />
      </div>
      <div className='date-picker-popup-controls'>
        <Button type='button' color='link' className='date-picker-modal-cancel' onClick={toggle}>
          Cancel
        </Button>
        <Button type='button' color='link' className='date-picker-modal-update' onClick={onClickUpdate}>
          Update
        </Button>
      </div>
    </div>
  );
};
